import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useTheme } from '../context/ThemeContext'
import { RoomSessionProvider, useRoomSessionApi } from '../context/RoomSessionContext'
import { PageErrorBoundary } from './ErrorBoundary'
import { Button } from './ui/Button'

export function Layout() {
  return (
    <RoomSessionProvider>
      <LayoutInner />
    </RoomSessionProvider>
  )
}

function LayoutInner() {
  const { user, logout } = useAuth()
  const { theme, toggle } = useTheme()
  const navigate = useNavigate()
  const { active, leaveSession } = useRoomSessionApi()

  return (
    <div className="app">
      <header className="app-header">
        <Link to="/" className="brand">
          <span className="brand-dot" />
          <span>family-vc</span>
        </Link>
        <nav className="app-nav">
          <NavLink to="/" end>
            Räume
          </NavLink>
          {user?.role === 'ADMIN' ? <NavLink to="/admin">Admin</NavLink> : null}
        </nav>
        <div className="app-right">
          <Button
            variant="ghost"
            size="sm"
            onClick={toggle}
            aria-label={theme === 'dark' ? 'Light Mode aktivieren' : 'Dark Mode aktivieren'}
          >
            {theme === 'dark' ? '☀︎' : '☾'}
          </Button>
          {user ? (
            <div className="user-pill">
              <span className="user-name">{user.displayName}</span>
              <Button
                variant="ghost"
                size="sm"
                onClick={async () => {
                  if (active) leaveSession()
                  await logout()
                  navigate('/login', { replace: true })
                }}
              >
                Abmelden
              </Button>
            </div>
          ) : null}
        </div>
      </header>
      <main className="app-main">
        <PageErrorBoundary>
          <Outlet />
        </PageErrorBoundary>
      </main>
    </div>
  )
}
